import { RootState } from 'store/rootReducer';
import { templateActions, templateTypes, templateSelector } from 'store/template';
import { tenantSelector, tenantTypes } from 'store/tenant';
import { uiStateActions, uiStateSelector, uiStateTypes } from 'store/uiState';

export interface OwnProps {
    open: boolean;
    setOpen(payload: boolean): void;
}
export interface StateProps {
    template?: templateTypes.Template;
    hasMandatoryDesignerSettings: boolean;
    tenant?: tenantTypes.Tenant;
}
export interface DispatchProps {
    resetCurrentTemplate(): void;
    editTemplateInformation(payload: templateTypes.AssetToBeEdited): void;
    addNotification(payload: uiStateTypes.Notification[]): void;
    onDeleteTemplate(payload: string): void;
    onRestoreTemplate(payload: string): void;
}
export type AllProps = OwnProps & StateProps & DispatchProps;

export const getAllProps = (props: AllProps) => {
    const { open,
        setOpen,
        template,
        hasMandatoryDesignerSettings,
        tenant,
        resetCurrentTemplate,
        editTemplateInformation,
        addNotification,
        onDeleteTemplate,
        onRestoreTemplate } = props;

    const ownProps: OwnProps = { open, setOpen };
    const stateProps: StateProps = { template, hasMandatoryDesignerSettings, tenant };
    const dispatchProps: DispatchProps = { resetCurrentTemplate,
        editTemplateInformation,
        addNotification,
        onDeleteTemplate,
        onRestoreTemplate };
    return { ownProps, stateProps, dispatchProps };
};

export const mapStateToProps = (state: RootState): StateProps => ({
    template: templateSelector.selectCurrentTemplate(state),
    hasMandatoryDesignerSettings: uiStateSelector.selectHasMandatoryDesignerSettings(state),
    tenant: tenantSelector.selectCurrentTenant(state),
});
export const mapDispatchToProps: DispatchProps = {
    resetCurrentTemplate: templateActions.resetCurrentTemplate,
    editTemplateInformation: templateActions.editTemplateInformation,
    addNotification: uiStateActions.addNotification,
    onDeleteTemplate: templateActions.onDeleteTemplate,
    onRestoreTemplate: templateActions.onRestoreTemplate,
};
